import { EVENT_TYPE_KEYS } from '@event/utils/event';
import { useParams } from 'react-router-dom';
import { NotFound } from 'src/routes/NotFound';

const withEventTypeCheck = <P extends object>(WrappedComponent: React.ComponentType<P>) => {
    const WithTypeCheck: React.FC<P> = (props: P) => {
        const { type } = useParams();

        const isValid = !type?.length || EVENT_TYPE_KEYS.includes(type);

        return isValid ? <WrappedComponent {...(props as P)} /> : <NotFound />;
    };

    return WithTypeCheck;
};

export { withEventTypeCheck };
